<template>
  <nav class="z-50 relative flex flex-wrap items-center justify-between px-2 py-3 bg-black-500 mb-3">
    <div class="container px-4 mx-auto flex flex-wrap items-center justify-between">
      <div class="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
        <router-link to="/" class="text-lg font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white">
          Swish Astrology
        </router-link>
        <button class="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none" type="button" @click="toggleMenu">
          <span class="i-mdi-menu"></span>
        </button>
      </div>
      <div :class="{'hidden': !isMenuOpen, 'flex': isMenuOpen}" class="lg:flex lg:flex-grow items-center">
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li class="nav-item w-full lg:w-auto lg:relative">
            <button @click="toggleDropdown" class="w-full lg:w-auto px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <span class="mr-1 i-mdi-star-outline"></span>
              <span>Swishes</span>
              <span class="ml-1 i-mdi-chevron-down" :class="{'transform rotate-180': isDropdownOpen}"></span>
            </button>
            <transition name="slide">
              <ul v-if="isDropdownOpen" class="w-full lg:absolute lg:top-full lg:left-0 lg:w-48 bg-black bg-opacity-50 backdrop-filter backdrop-blur-md py-1 lg:mt-1 max-h-96 overflow-y-scroll">
                <li v-for="swish in store.swishes" :key="swish.id">
                  <a @click="viewSwish(swish.name)" class="block px-4 py-2 text-white cursor-pointer">{{ swish.name }}</a>
                </li>
              </ul>
            </transition>
          </li>
          <li v-if="!store.user" class="nav-item">
            <a @click="navigateTo('/login')" class="px-3 py-2 flex text-xs items-center uppercase font-bold leading-snug text-white hover:opacity-75 cursor-pointer">
              <span class="mr-1 i-mdi-login"></span>
              <span>Login</span>
            </a>
          </li>
          <li v-else class="nav-item">
            <a @click="logout" class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75 cursor-pointer">
              <span class="mr-1 i-mdi-logout"></span>
              <span>Logout</span>
            </a>
          </li>
          <li v-if="store.isAdmin" class="nav-item">
            <a @click="navigateTo('/admin')" class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75 cursor-pointer">
              <span class="mr-1 i-mdi-shield-account"></span>
              <span>Admin</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const store = useStore();
const isMenuOpen = ref(false);
const isDropdownOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const navigateTo = (path: string) => {
  router.push(path);
  isMenuOpen.value = false;
  isDropdownOpen.value = false;
};

const viewSwish = (name: string) => {
  store.setSelectedSwish(name);
  isMenuOpen.value = false;
  isDropdownOpen.value = false;
  router.push('/');
};

const logout = () => {
  store.logout();
  router.push('/');
  isMenuOpen.value = false;
  isDropdownOpen.value = false;
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
